import { useId } from "react";

/** Stable DOM id: explicit `id`, then `name`, then React `useId()`. */
export function useFieldId(id?: string, name?: string): string {
  const generatedId = useId();
  return id ?? name ?? generatedId;
}
